import { useLocation, useNavigation } from "react-router-dom";

/**
 * The full-screen loader: Infra Junction's mark building itself, the brand suite's "Build" loader
 * (2026-10-08) — the frame draws on, the i's stem grows, the J lands and the dot pops, on a loop
 * (`.sy-loader`, `src/index.css`). The shapes are `theme/components/logo.tsx`'s frame and glyphs,
 * split apart so each can animate on its own; the order matters, the CSS targets them by
 * `:nth-child`. The template ships no app-level loading screen to copy.
 *
 * A translucent, blurred overlay, so the page underneath shows through rather than being blanked
 * out (owner, 2026-10-05). `main.tsx` mounts it twice: as the router's `HydrateFallback` (the
 * first `rootLoader` run awaits `/api/identity/me` before anything can render) and through
 * `NavigationLoader` below. The portal's `components/site-loader.tsx` is the same artwork, motion
 * and blur, kept in step by hand.
 */
export default function AppLoader() {
  return (
    <div className="sy-loader-screen" role="status" aria-label="Loading">
      <svg className="sy-loader" xmlns="http://www.w3.org/2000/svg" viewBox="-4 -6 318 362" aria-hidden>
        <path pathLength={100} d="M291,263 L291,93 L154,18 L18,93 L18,268 L106,319" />
        <path d="M85,187 L127,187 L127,352 L85,328 Z" />
        <path d="M157,133 L222,120 L222,298 C222,330 202,350 172,350 L157,350 L157,312 L166,312 C177,312 184,305 184,294 L184,151 L157,155 Z" />
        <path d="M78,139 L127,122 L127,171 L78,177 Z" />
      </svg>
    </div>
  );
}

/**
 * The same overlay over the current page while a navigation to another page runs its loaders —
 * React Router keeps the old page mounted meanwhile. Only a pathname change: a same-screen
 * `?page=`/filter/search refetch keeps its own cue, `TableView` dimming the table.
 */
export function NavigationLoader() {
  const { pathname } = useLocation();
  const navigation = useNavigation();
  return navigation.location && navigation.location.pathname !== pathname ? <AppLoader /> : null;
}
